import { render, staticRenderFns } from "./BaseGallery.vue?vue&type=template&id=38377262&"
import script from "./BaseGallery.vue?vue&type=script&lang=js&"
export * from "./BaseGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports